import { type FC, type ReactElement, type ReactNode } from 'react'
import cn from 'classnames'

type TTransferReviewSection = TReviewContentSection & {
  sectionTitle: string
  isPII?: boolean
}

interface TReviewContentSection {
  sectionContentPrimary: ReactNode | string
  sectionContentSecondary?: ReactElement | string[] | null
  className?: string
  isPII?: boolean
}

export const TransferReviewSection: FC<TTransferReviewSection> = ({
  sectionTitle,
  sectionContentPrimary,
  sectionContentSecondary,
  isPII,
}) => {
  return (
    <div className="flex flex-row py-sm justify-between border-b border-light">
      <div>
        <p className="text-text-meta typo-primary-base-regular">{sectionTitle}</p>
      </div>
      <ReviewContentSection
        isPII={isPII}
        sectionContentPrimary={sectionContentPrimary}
        sectionContentSecondary={sectionContentSecondary}
      />
    </div>
  )
}

export const ReviewContentSection: FC<TReviewContentSection> = ({
  className,
  sectionContentPrimary,
  sectionContentSecondary,
  isPII,
}) => {
  return (
    <div
      className={cn(
        `flex flex-col text-right`,
        {
          'fs-exclude': isPII,
        },
        [className],
      )}
    >
      <p className="text-text-header typo-primary-base-semibold">{sectionContentPrimary}</p>
      {Array.isArray(sectionContentSecondary)
        ? sectionContentSecondary.map((text: string) => (
            <p key={crypto.randomUUID()} className="text-text-meta typo-primary-sm-regular">
              {text}
            </p>
          ))
        : sectionContentSecondary}
    </div>
  )
}
